package tta.destinigo.talktoastro.core.navigation_decompose.configruation

import io.github.vinceglb.filekit.PlatformFile
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import tta.destinigo.talktoastro.shared.data.CommonExpertInfo

@Serializable
sealed class DialogConfiguration {
    @Serializable
    data object LoginPageDialogConfig : DialogConfiguration()

    @Serializable
    data class QueueDialogConfig(
        val expertInfo: CommonExpertInfo,
        val type:String,
        val isChatAvailable:Boolean,
        val isCallAvailable:Boolean,
        val waitingTime:String,
        val queNumber:Int,
        val onQueueJoined:()->Unit
    ): DialogConfiguration()

    @Serializable
    data class QueueStatusDialogConfig(
        val expertInfo: CommonExpertInfo,
        val onQueueJoined: () -> Unit,
        val validationMessage:String?=null,
    ): DialogConfiguration()

    @Serializable
    data class ExitDialogConfig(
        val onExitConfirmation:()->Unit,
    ): DialogConfiguration()

    @Serializable
    data class ChatDurationDialog(
        val isEmergencyChat:Boolean,
        val expertInfo: CommonExpertInfo,
    ):DialogConfiguration()

    @Serializable
    data class CallDurationDialog(
        val isEmergencyCall:Boolean,
        val expertInfo: CommonExpertInfo,
    ):DialogConfiguration()

    @Serializable
    data object CallOptionDialog:DialogConfiguration()

    @Serializable
    data class ChatQueueDialog(
        val expertInfo: CommonExpertInfo,
        val timerTime:Long,
        val category:String
    ):DialogConfiguration()

    @Serializable
    data object PermissionDialog:DialogConfiguration()

    @Serializable
    data class ImageViewerUrlDialog(
        val imageUrl:String,
    ) :DialogConfiguration()

    @Serializable
    data class ImageViewerPlatformDialog(
        @Contextual val imageFile:PlatformFile,
    ) :DialogConfiguration()


//    data class OpenPaymentPage(
//
//    )
}